import CloseIcon from '@mui/icons-material/Close';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Grid,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import { useForgotPasswordMutation } from '../../../app/Slices/SevenDayApiSlice';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import { CustomIconButton } from '../../../layout/styledcomponents/CustomIconButton';
import { CustomTextField } from '../../../layout/styledcomponents/CustomTextField';
import toast from '../../shared/Toast';

export default function ForgotPasswordModal(props: any) {
    const { onClose, open, onChange } = props;
    const [resetPassword] = useForgotPasswordMutation();
    const isMobile = useMediaQuery('(max-width: 770px)');
    const [email, setEmailAddress] = useState('');

    const handleEmailAddress = (event: any) => {
        setEmailAddress(event?.target?.value?.toLowerCase());
    };

    const theme = useTheme();

    const handleResetLink = () => {
        const requestBody = {
            email: email,
        };
        resetPassword(requestBody).then((data: any) => {
            if (data) {
                if (
                    data?.error?.data !== 'Reset Password link sent to email.'
                ) {
                    toast.error(
                        `Failed to send reset password link, please check email is correct`,
                    );
                } else {
                    toast.success(
                        `Reset password link has been sent to ${email}`,
                    );
                    handleCloseChangeModal();
                }
            } else {
                toast.error(
                    `Failed to send reset password link, please check email is correct`,
                );
            }
        });
    };

    const handleClose = () => {
        onClose();
        setEmailAddress('');
    };

    const handleCloseChangeModal = () => {
        onChange();
        setEmailAddress('');
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <Grid
                sx={{
                    width: '100%',
                    height: '100%',
                }}
            >
                <Grid
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        textAlign: 'left',
                        height: '50px',
                        width: isMobile ? '97%' : '600px',
                        alignContent: 'center',
                        alignItems: 'center',
                        borderBottom: `1px solid ${theme.palette.lightGrey.main}`,
                    }}
                >
                    <Grid
                        sx={{
                            display: 'flex',
                            alignContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            width: '90%',
                            paddingLeft: '18px',
                        }}
                    >
                        <Typography variant='h6'>Reset Password</Typography>
                    </Grid>
                    <Grid
                        sx={{
                            display: 'flex',
                            alignContent: 'center',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                            width: '10%',
                        }}
                    >
                        <CustomIconButton
                            sx={{
                                '&:hover': {
                                    cursor: 'pointer',
                                    color: theme.palette.textAccent.main,
                                    backgroundColor: 'transparent',
                                    background: 'none',
                                },
                            }}
                            onClick={handleClose}
                        >
                            <CloseIcon />
                        </CustomIconButton>
                    </Grid>
                </Grid>
                <DialogContent
                    dividers
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '200px',
                    }}
                >
                    <DialogContentText
                        sx={{
                            display: 'flex',
                            width: '100%',
                            flexDirection: isMobile ? 'column' : 'row',
                        }}
                    >
                        <>
                            <Grid
                                sx={{
                                    display: 'flex',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                    width: isMobile ? '100%' : '30%',
                                }}
                            >
                                <Typography>Email Address:</Typography>
                            </Grid>
                            <Grid
                                sx={{
                                    display: 'flex',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                    paddingTop: isMobile ? ' 10px' : '0px',
                                    paddingLeft: isMobile ? '0px' : '10px',
                                    width: isMobile ? '100%' : '70%',
                                }}
                            >
                                <CustomTextField
                                    type='text'
                                    fullWidth
                                    value={email}
                                    onChange={handleEmailAddress}
                                />
                            </Grid>
                        </>
                    </DialogContentText>
                </DialogContent>{' '}
                <DialogActions>
                    <Grid>
                        {' '}
                        <CustomButton
                            variant='contained'
                            color='primary'
                            // autoFocus
                            onClick={handleResetLink}
                        >
                            send
                        </CustomButton>
                    </Grid>
                </DialogActions>
            </Grid>
        </Dialog>
    );
}
